import * as React from "react";
import styled from "styled-components";
import { useNavigate } from 'react-router-dom'; // Correct import for navigation hook
import axios from 'axios';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import CircularProgress from '@mui/material/CircularProgress';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import Tooltip from '@mui/material/Tooltip'; // Import Tooltip from Material-UI
import { API_BASE_URL } from '../../config/apiConfig';
import { headerLogo, formArrow } from '../../assets/images';

const data = [
    {
        firstName: "First name",
        lastName: "Last name",
        phoneNumber: "Phone number",
        email: "Email",
        gender: "Gender",
        birthday: "Birthday",
    },
];

export function PersonalDetails() {
    const navigate = useNavigate();
    const [profile, setProfile] = React.useState(null);
    const [errorMessage, setErrorMessage] = React.useState('');
    const [openSnackbar, setOpenSnackbar] = React.useState(false);
    const [loading, setLoading] = React.useState(false); // State to handle loader

    React.useEffect(() => {
        const token = sessionStorage.getItem('token');
        if (token) {
            axios({
                method: 'post',
                url: `${API_BASE_URL}/user/get-profile`,
                headers: {
                    Authorization: token
                }
            }).then(response => {
                console.log(response.data);
                
                console.log(response.data.data[0]);

                setProfile(response.data.data[0]);
            }).catch(error => {
                console.error('Error fetching profile', error);
            });
        }
    }, []);

    const handleSubmit = async (event) => {
        event.preventDefault();
        const token = sessionStorage.getItem('token');
       
        let body = {
            gender: event.target.gender.value,
            dob: event.target.birthday.value,
            firstname: event.target.firstName.value,
            lastname: event.target.lastName.value,
            mobile: event.target.phoneNumber.value,
            email: event.target.email.value,
        }
        
        console.log(body);
        
        // Check for missing values in the form
        if (!body.gender || !body.dob || !body.firstname || !body.lastname || !body.mobile || !body.email) {
            setErrorMessage('All fields are required. Please fill out all fields.');
            setOpenSnackbar(true);
            return;
        }

        if (token && body) {
            sessionStorage.setItem('name', body.firstname);
            setLoading(true); // Start loading
            try {
                const response = await fetch(`${API_BASE_URL}/user/update-profile`, {
                    method: 'post',
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: token
                    },
                    body: JSON.stringify(body)
                });
                const data = await response.json();
                console.log(data);
                navigate("/spendType");
            } catch (error) {
                console.error('Error updating profile', error);
            } finally {
                setLoading(false); // Stop loading regardless of the outcome
            }
        }
    };

    const handleCloseSnackbar = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpenSnackbar(false);
    };

    return (
        <MainContainer>
            <ContentWrapper>
                <LeftColumn>
                    <LeftColumnContent>
                    <div style={{display:'flex',flexDirection:'row',alignItems:'center',gap:'10px'}}>
                        <Logo onClick={() =>  window.open("/", "_blank")} src={headerLogo} alt="Logo" />
                        </div>
                        <Heading>Let's get started</Heading>
                        <StepIndicator>
                            Step 01 / 04 
                            <Tooltip title="Click here to learn more about us.." arrow> {/* Tooltip added here */}
                                <InfoIcon onClick={() => window.open("/about", "_blank")}>
                                    <InfoOutlinedIcon style={{ width: '16px', height: '16px',backgroundColor:'#e9fe53', borderRadius:'100px'}} />
                                </InfoIcon>
                            </Tooltip>
                        </StepIndicator>
                        <ProgressBar>
                            <ProgressIndicator />
                        </ProgressBar>
                        <NextStep>Next: More details about you</NextStep>
                    </LeftColumnContent>
                </LeftColumn>
                <RightColumn>
                    <FormContainer onSubmit={handleSubmit}>
                        <FormWrapper>
                            <Snackbar open={openSnackbar} autoHideDuration={6000} onClose={handleCloseSnackbar}>
                                <Alert onClose={handleCloseSnackbar} severity="error" sx={{ width: '100%' }}>
                                    {errorMessage}
                                </Alert>
                            </Snackbar>
                            {loading ? (
                                <CircularProgress /> // Display loader when updating profile
                            ) : profile ? (
                                <React.Fragment>
                                    <InputRow>
                                        <InputGroup>
                                            <Label htmlFor="firstName">
                                                {profile.firstName || 'First name'}
                                            </Label>
                                            <Input type="text" id="firstName" defaultValue={profile.firstname?.split(" ")[0]} />
                                        </InputGroup>
                                        <InputGroup>
                                            <Label htmlFor="lastName">{profile.lastName || 'Last name'}</Label>
                                            <Input type="text" id="lastName" defaultValue={profile.lastname? profile.lastname : profile.firstname?.split(" ")[1]} />
                                        </InputGroup>
                                    </InputRow>
                                    <InputRow>
                                        <InputGroup>
                                            <Label htmlFor="phoneNumber">
                                                { 'Phone number'}
                                            </Label>
                                            <Input type="tel" id="phoneNumber" defaultValue={profile.mobile} />
                                        </InputGroup>
                                        <InputGroup>
                                            <Label htmlFor="email">{'Email'}</Label>
                                            <Input type="email" id="email" defaultValue={profile.email} />
                                        </InputGroup>
                                    </InputRow>
                                    <InputRow>
                                        <InputGroup>
                                            <Label htmlFor="gender">{ 'Gender'}</Label>
                                            <SelectWrapper>
                                                <Select id="gender" defaultValue={profile.gender}>
                                                    <option value="male">Male</option>
                                                    <option value="female">Female</option>
                                                    <option value="others">Others</option>
                                                </Select>
                                            </SelectWrapper>
                                        </InputGroup>
                                        <InputGroup>
                                            <Label htmlFor="birthday">{'Birthday'}</Label>
                                            <Input type="date" id="birthday" defaultValue={profile.dob} onFocus={(e) => e.target.removeAttribute('readonly')} />
                                        </InputGroup>
                                    </InputRow>
                                </React.Fragment>
                            ) : (
                                data.map((item, index) => (
                                    <React.Fragment key={index}>
                                        <InputRow>
                                            <InputGroup>
                                                <Label htmlFor={`firstName${index}`}>
                                                    {item.firstName}
                                                </Label>
                                                <Input type="text" id={`firstName${index}`} />
                                            </InputGroup>
                                            <InputGroup>
                                                <Label htmlFor={`lastName${index}`}>{item.lastName}</Label>
                                                <Input type="text" id={`lastName${index}`} />
                                            </InputGroup>
                                        </InputRow>
                                        <InputRow>
                                            <InputGroup>
                                                <Label htmlFor={`phoneNumber${index}`}>
                                                    {item.phoneNumber}
                                                </Label>
                                                <Input type="tel" id={`phoneNumber${index}`} />
                                            </InputGroup>
                                            <InputGroup>
                                                <Label htmlFor={`email${index}`}>{item.email}</Label>
                                                <Input type="email" id={`email${index}`} />
                                            </InputGroup>
                                        </InputRow>
                                        <InputRow>
                                            <InputGroup>
                                                <Label htmlFor={`gender${index}`}>{item.gender}</Label>
                                                <SelectWrapper>
                                                    <Select id={`gender${index}`}>
                                                        <option value="male">Male</option>
                                                        <option value="female">Female</option>
                                                        <option value="others">Others</option>
                                                    </Select>
                                                </SelectWrapper>
                                            </InputGroup>
                                            <InputGroup>
                                                <Label htmlFor={`birthday${index}`}>{item.birthday}</Label>
                                                <Input type="date" id={`birthday${index}`} onFocus={(e) => e.target.removeAttribute('readonly')} />
                                            </InputGroup>
                                        </InputRow>
                                    </React.Fragment>
                                ))
                            )}
                            <ButtonRow>
                                <SubmitButton type="submit">
                                    <ButtonText>SUBMIT</ButtonText>
                                    <ArrowIcon src={formArrow} alt="Arrow Icon" />
                                </SubmitButton>
                            </ButtonRow>
                        </FormWrapper>
                    </FormContainer>
                </RightColumn>
            </ContentWrapper>
            <FooterWrapper>
        <NavigationLinks>
          <Link onClick={() => window.open("/", "_blank")}>Home</Link>
          <Link onClick={() => window.open("/about", "_blank")}>About Us</Link>
        </NavigationLinks>
        <Copyright>
          Copyright © 2024. SPOELT. All rights reserved
        </Copyright>
      </FooterWrapper>
        </MainContainer>
    );
}

const MainContainer = styled.main`
  background-color: #fff;
  padding: 39px 80px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100vh;
  @media (max-width: 991px) {
    padding: 0 20px;
  }
`;

const ContentWrapper = styled.div`
  display: flex;
  gap: 20px;
  @media (max-width: 991px) {
    flex-direction: column;
    align-items: stretch;
    gap: 0;
  }
`;

const LeftColumn = styled.section`
  width: 35%;
  margin-left: 0;
  @media (max-width: 991px) {
    width: 100%;
  }
`;

const LeftColumnContent = styled.div`
  display: flex;
  flex-direction: column;
  @media (max-width: 991px) {
    margin-top: 40px;
  }
`;

const Logo = styled.img`
  width: 130px;
  max-width: 100%;
  object-fit: contain;
  cursor: pointer; // Added cursor pointer for logo
`;

const InfoIcon = styled.div`
  width: 10px; // Adjust size as needed
  margin-left: 5px; // Space between text and icon
  cursor: pointer; // Added cursor pointer for info icon
`;

const Heading = styled.h1`
  color: #202023;
  margin-top: 129px;
  font: 800 60px/65px Inter, sans-serif;
  @media (max-width: 991px) {
    margin-top: 30px;
    margin-bottom: 10px;
    font-size: 40px;
    line-height: 48px;
  }
`;

const StepIndicator = styled.p`
  display: flex;
  flex-direction: row;
  color: #202023;
  letter-spacing: -0.24px;
  margin-top: 30px;
  font: 400 12px/130% Metrophobic, sans-serif;
  @media (max-width: 991px) {
    margin-top: 10px;
  }
`;

const ProgressBar = styled.div`
  border: 1px solid rgba(32, 32, 35, 1);
  display: flex;
  margin-top: 8px;
  padding: 1px 0;
  @media (max-width: 991px) {
    padding-right: 20px;
  }
`;

const ProgressIndicator = styled.div`
  background-color: #e9fe53;
  width: 25%;
  height: 12px;
`;

const NextStep = styled.p`
  color: #202023;
  letter-spacing: -0.24px;
  margin-top: 9px;
  font: 400 12px/130% Metrophobic, sans-serif;
`;

const RightColumn = styled.section`
  width: 65%;
  margin-left: 20px;
  @media (max-width: 991px) {
    width: 100%;
    margin-left: 0;
  }
`;

const FormContainer = styled.div`
  display: flex;
  margin-top: 69px;
  flex-grow: 1;
  flex-direction: column;
  @media (max-width: 991px) {
    max-width: 100%;
    margin-top: 10px;
  }
`;

const FormWrapper = styled.form`
  border: 1px solid rgba(32, 32, 35, 1);
  display: flex;
  flex-direction: column;
  padding: 53px 40px;
  @media (max-width: 991px) {
    max-width: 100%;
    padding: 0 20px;
  }
`;

const InputRow = styled.div`
  display: flex;
  gap: 20px;
  font-size: 12px;
  color: #202023;
  font-weight: 400;
  text-transform: uppercase;
  letter-spacing: -0.24px;
  line-height: 130%;
  margin-bottom: 30px;
  @media (max-width: 991px) {
    flex-wrap: wrap;
    margin-top: 10px;
    margin-bottom: 10px;
  }
`;

const InputGroup = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  width: fit-content;
`;

const Label = styled.label`
  font-family: Metrophobic, sans-serif;
`;

const Input = styled.input`
padding-left: 10px;
padding-right: 10px;
font:  16px/130% Metrophobic, sans-serif;

  border: 1px solid rgba(32, 32, 35, 1);
  border-radius: 1px;
  margin-top: 10px;
  height: 50px;
`;

const SelectWrapper = styled.div`
  border: 1px solid rgba(32, 32, 35, 1);
  border-radius: 1px;
  display: flex;
  margin-top: 10px;
  height: 50px;
  justify-content: flex-end;
  align-items: center;
  @media (max-width: 991px) {
    padding: 0 20px;
  }
`;

const Select = styled.select`
  border: none;
  background: transparent;
  width: 100%;
  cursor: pointer;
  padding-left: 10px;
margin-right: 10px;
font:  16px/130% Metrophobic, sans-serif;

`;

const SelectIcon = styled.img`
  width: 13px;
  object-fit: contain;
`;

const ButtonRow = styled.div`
  display: flex;
  //margin-top: 46px;
  gap: 20px;
  font-size: 16px;
  font-weight: 400;
  text-transform: uppercase;
  letter-spacing: -0.32px;
  line-height: 130%;
  width: 50%;
  @media (max-width: 991px) {
    flex-wrap: wrap;
    margin-top: 20px;
    margin-bottom: 20px;
width: 100%;  }
`;

const SubmitButton = styled.button`
  display: flex;
  justify-content: space-between;
  align-items: center;
  border: 1px solid rgba(32, 32, 35, 1);
  border-radius: 1px;
  background-color: #e9fe53;
  gap: 8px;
  color: #202023;
  white-space: nowrap;
  flex: 1;
  padding: 15px 13px;
  @media (max-width: 991px) {
    padding-right: 20px;
    white-space: initial;
  }
`;

const ButtonText = styled.span`
font:  16px/130% Metrophobic, sans-serif;
`;

const ArrowIcon = styled.img`
  width: 11px;
  object-fit: contain;
  fill: #202023;
`;

const GoogleSignUpButton = styled.button`
  display: flex;
  justify-content: space-between;
  align-items: center;
  border: 1px solid rgba(32, 32, 35, 1);
  border-radius: 1px;
  background-color: #202023;
  gap: 8px;
  color: #fff;
  flex: 1;
  padding: 13px;
`;

const GoogleLogo = styled.img`
  width: 24px;
  object-fit: contain;
`;

const GoogleButtonText = styled.span`
  font-family: Metrophobic, sans-serif;
`;

const GoogleArrowIcon = styled.img`
  width: 11px;
  object-fit: contain;
  fill: #fff;
`;

const Copyright = styled.p`
  color: #828282;
  align-self: flex-end;
 // margin-top: 53px;
  font: 400 12px Metrophobic, sans-serif;
  @media (max-width: 991px) {
   // margin-top: 40px;
    align-self: center;
  }
`;


const FooterWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  //padding: 20px;
  @media (max-width: 991px) {
    flex-direction: column;
    align-items: flex-start;
  }
`;
const NavigationLinks = styled.div`
  display: flex;
  justify-content: left;
  gap: 20px;
  margin-top: auto;
  margin-bottom:auto;
 // margin-bottom:5px;
  font: 600 22px Metrophobic, sans-serif;
  @media (max-width: 991px) {
    font: 600 16px Metrophobic, sans-serif;
    margin-top: 40px;
    align-self: center;
  }
`;

const Link = styled.span`
  color: #202023;
  cursor: pointer;
`;